import styled from '@src/styled-components';
import React from 'react';


export interface IScoreExecutionProps {
  description?: string;
  results: any[];
  score: number
}

export interface IScoreExecutionState {
  result: string
}

export default class ScoreExecutionComponent extends React.Component<IScoreExecutionProps, IScoreExecutionState> {
  constructor(props: IScoreExecutionProps) {
    super(props);
  }
  handleScoreResults() {
    const res = this.props.results.find((e: any) => {
      return (this.props.score >= e.min && this.props.score <= e.max)
    })
    let msg = ''
    if (res) {
      msg = res.label.replace(/{{value}}/g, this.props.score)
    }
  return msg
  }

  render() {
    return (
      <Wrapper>
        <>
          <p>{this.props.description}</p>
          <p>{this.handleScoreResults()}</p>
        </>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  .button-style{
    margin-right: 20px;
  }
`